var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vertical-axis flex",style:({
        'align-items': _vm.align === 'right' ? 'flex-end' : 'flex-start',
        'justify-content': _vm.justify.length > 0 ? _vm.justify : '',
}),attrs:{"data-testid":"VerticalAxis"}},[_c('div',{staticClass:"tick"},[_vm._v(" "+_vm._s(_vm.showMaxPrice)+" ")]),_c('div',{staticClass:"tick"},[_vm._v(" "+_vm._s(_vm.showMinPrice)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }